import { render, staticRenderFns } from "./UsersPrivilegeEmployeeBranches.vue?vue&type=template&id=62b3e93c&scoped=true&"
import script from "./UsersPrivilegeEmployeeBranches.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeeBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3e93c",
  null
  
)

export default component.exports